import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { filter, first, switchMap } from 'rxjs/operators';

/**
 * With the service worker, a deploy reaches a user once it is downloaded. It is
 * switched to at the next navigation, as a full load of the screen the user was
 * going to anyway, so nothing typed is lost in a reload out of nowhere. A
 * broken cache reloads at once.
 */
@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  constructor(private updates: SwUpdate, private router: Router) {}

  start(): void {
    if (!this.updates.isEnabled) return;
    this.updates.versionUpdates.pipe(
      filter(e => e.type === 'VERSION_READY'),
      first(),
      switchMap(() => this.router.events.pipe(filter((e): e is NavigationStart => e instanceof NavigationStart), first())),
    ).subscribe(nav => document.location.assign(nav.url));
    this.updates.unrecoverable.subscribe(() => document.location.reload());
  }
}
